/**
 * T-07 / T-1g-CODEC (fixture leg). §2.4's verified hermes∩skill1
 * intersection is exactly two variants — `MediaRole` (types.ts) already
 * pins the TS union; this module is where that pin is enforced at runtime
 * and where mime is resolved codec-honestly (never assumed).
 *
 * The live transcription half of T-1g-CODEC (iOS m4a / Android webm
 * end-to-end via the coordinator) is GATED on 1l and out of this batch —
 * only the shape/mime/role fixture proof ships here.
 */

import type { CaptureModality, MediaRole } from "./types";
import { extFromMime } from "./blob-store";

export const MEDIA_ROLES: readonly MediaRole[] = ["primary_photo", "voice_annotation"];

export function roleForModality(modality: CaptureModality): MediaRole {
  switch (modality) {
    case "photo":
      return "primary_photo";
    case "audio":
      return "voice_annotation";
  }
}

/**
 * Codec-honest mime resolution: always the actual recorded blob's `type`,
 * never a hardcoded/assumed value. A blob with no recorded type is a
 * capture-layer bug, not something this function should paper over.
 */
export function resolveMime(blob: Blob): string {
  if (!blob.type) {
    throw new Error(
      "media-role: blob has no recorded mime type — codec-honest mime must never be assumed (§2.4)",
    );
  }
  return blob.type;
}

export { extFromMime };
